import { IConfiguration } from '../modules/generics/generic/types'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IGeneric } from '../modules/generics/generic/types'
interface IState {
  generic: IGeneric
  loading: boolean
  error: string
  configuration: IConfiguration
  configurationLoading: boolean
}

const initialImpactValues = {
  carbon: null,
  biodiversity: null,
  eutrophication: null,
  waterUsage: null,
  landUse: null,
}

const initialFlagValues = {
  l1_LandUseChangeCarbon: null,
  l1_LandManagementCarbon: null,
  l1_LandManagementNonCarbon: null,
  l1_NonLandCarbon: null,
  l1_UnverifiedRemovalsCarbon: null,
  l1_VerifiedRemovalsCarbon: null,
  l0_NetCarbon: null,
}

const initialDQSValues = {
  overall: null,
  time: null,
  geography: null,
  reliability: null,
  completeness: null,
  techSystem: null,
  techCrop: null,
  siteEnergy: null,
}

const initialState: IState = {
  configuration: {
    productTypes: [],
    productionSystems: [],
  },
  generic: {
    code: '',
    productGroupId: null,
    productCategoryId: null,
    researcherName: '',
    researcherEmail: '',
    userEmail: '',
    lastUpdatedName: '',
    lastPublishedDate: '',
    updated: '',
    state: 0,
    isVerified: false,
    verificationComments: null,
    verifiedByName: null,
    verifiedByEmail: null,
    verifiedOn: null,
    id: 0,
    name: '',
    productType: null,
    productId: null,
    gpcAttributeId: null,
    gpcValueId: null,
    productionSystem: null,
    isBom: false,
    referenceInformation: null,
    farming: initialImpactValues,
    transport: initialImpactValues,
    processing: initialImpactValues,
    packaging: initialImpactValues,
    storage: initialImpactValues,
    sale: initialImpactValues,
    aggregated: initialImpactValues,
    flag: initialFlagValues,
    dqs: initialDQSValues,
  },
  loading: true,
  configurationLoading: true,
  error: '',
}

const genericSlice = createSlice({
  name: 'generic',
  initialState,
  reducers: {
    genericRequest(state) {
      state.loading = true
    },
    genericSuccess(state, action: PayloadAction<IGeneric>) {
      state.loading = false
      state.generic = {
        ...action.payload,
        isBom: action.payload.isBom ?? false,
        referenceInformation: action.payload.referenceInformation ?? null,
      }
    },
    genericFailure(state, action: PayloadAction<string>) {
      state.loading = false
      state.error = action.payload
    },
    genericConfigurationRequest(state) {
      state.configurationLoading = true
    },
    genericConfigurationFailure(state) {
      state.configurationLoading = false
    },
    configuration(state, action: PayloadAction<IConfiguration>) {
      state.configurationLoading = false
      state.configuration = action.payload
    },
    handlePublishStatus(state, action: PayloadAction<number>) {
      state.generic.state = action.payload
    },
    addNote(state, action) {
      if (state.generic[action.payload.key] == null) {
        state.generic[action.payload.key] = []
      }
      state.generic[action.payload.key].push(action.payload.value)
    },
    setDefaultGeneric: () => initialState,
  },
})

export default genericSlice.reducer
export const {
  genericRequest,
  genericSuccess,
  genericFailure,
  handlePublishStatus,
  setDefaultGeneric,
  configuration,
  addNote,
  genericConfigurationRequest,
  genericConfigurationFailure,
} = genericSlice.actions
